import * as messageService from "../../services/message.service";
import * as quoteService from '../../services/quote.service';
import * as leadsService from '../../services/leads.service';
import * as authService from '../../services/auth.service';

const state = {
    quoteSingle:{},
    quoteDealerManagerList:[],
    quoteSteps:{
      // client_vehicle_details
      vehicle: {
        id: '',
        clientId: '',
        dealerId: '',
        referralPartnerId: '',
        referDealerId: '',
        leadSource: '',
        salaryPackagingProviderId: 1,
        salaryPackagingProviderFee: '',
        vehicleCondition: 'N',
        odometerReading: '',
        year: '',
        make: '',
        model: '',
        variant: '',
        bodyType: '',
        vehicleCategoryId: 1,
        fuelFlatRate: '',
        fuelCostPerKM: '',
        tyresCostPerKM: '',
        serviceCostPerKM: '',
        transmissionId: 1,
        fuelTypeId: 1,
        colour: '',
        accessories: '',
        term: 60,
        rvRate: '',
        annualKms: '',
        noFinanceInsurance: 0,
        comprehensiveInsurer: '',
        comprehensiveInsurancePremium: '',
        businessUsePercentage: 0,
        stampDuty: 0,
        registration: '',
        gstOnAsset: '',
        gstOnAssetActual: '',
        totalDriveAwayCost: '',
        chanageBudgetsYesNo: 'A',
        fuelBudget: '',
        serviceBudget: '',
        tyreBudget: '',
        needToCompeteYesNo: 'No',
        dealerBrokerage: '',
        status: 1,
        sortOrder: 6,
        has_messages: 0,
        messages_for_vsa: 0,
        messages_for_other: 0,
        privacyConsent: 0,
        settlementDate: '',
        fa_no: '',
        edd: ''
      },
      // Client information
      client: {
        title: '',
        gender: '',
        firstName: '',
        middleName: '',
        lastName: '',
        mobileNumber: '',
        email: '',
        grossAnnualSalary: 0,
        payPeriod: 'Weekly',
        dateOfBirth: '',
        anotherNameYesNo: 'No',
        otherFirstName: '',
        otherMiddleName: '',
        otherLastName: '',
        driversLicenceNumber: '',
        driversLicenceCardNumber: '',
        driversLicenceExpiryDate: '',
        driversLicenceState: '',
        driversLicenceType: 'Full',
        maritalStatus: 'Single',
        numberOfDependents: '',
        partnerAnnualGrossSalary: '',
        australianResidencyStatusId: 1,
        visaTypeId: '',
        citizenOfAnotherCountryYesNo: 'No',
        citizenOfAnotherCountry: '',
        hAddressUnitNumber: '',
        hAddressStreetNumber: '',
        hAddressStreetName: '',
        hAddressSuburb: '',
        hAddressState: '',
        hAddressPostcode: '',
        hAddressCountry: 'Australia',
        hAddressTimeAtYears: 0,
        hAddressTimeAtMonths: 0,
        hAddressResidenceStatus: '',
        hAddressMonthlyRentalAmount: '',
        pHAddressUnitNumber: '',
        pHAddressStreetNumber: '',
        pHAddressStreetName: '',
        pHAddressSuburb: '',
        pHAddressState: '',
        pHAddressPostcode: '',
        pHAddressCountry: 'Australia',
        pHAddressTimeAtYears: '',
        pHAddressTimeAtMonths: 0,
        postalAddressAndHomeAddressAreSameYesNo: 'Yes',
        postalAddressPOBoxNumber: '',
        postalAddressSuburb: '',
        postalAddressState: '',
        postalAddressPostcode: '',
        status: 1
      },
      //client_employment_detailsgetStepNumber
      employment: {
        quoteId: '',
        employerName: '',
        tradingName: '',
        ABNOfEmployerOnPayslip: '',
        websiteAddress: '',
        employmentStatus: '',
        occupation: '',
        employerAddressBuildingName: '',
        employerAddressUnitNumber: '',
        employerAddressStreetNumber: '',
        employerAddressStreetName: '',
        employerAddressSuburb: '',
        employerAddressState: '',
        employerAddressPostcode: '',
        employerAddressTimeAtYears: 0,
        employerAddressTimeAtMonths: 0,
        employerContactName: '',
        employerContactNumber: '',
        pEmployerName: '',
        pABNOfEmployerOnPayslip: '',
        pEmploymentStatus: '',
        pOccupation: '',
        pEmployerAddressBuildingName: '',
        pEmployerAddressUnitNumber: '',
        pEmployerAddressStreetNumber: '',
        pEmployerAddressStreetName: '',
        pEmployerAddressSuburb: '',
        pEmployerAddressState: '',
        pEmployerAddressPostcode: '',
        pEmployerAddressTimeAtYears: 0,
        pEmployerAddressTimeAtMonths: 0,
        pEmployerContactName: '',
        pEmployerContactNumber: '',
        investmentIncome: 0,
        govConvertibleIncome: 0,
        otherIncome: 0,
        noteOnOtherIncome: ''
      },
      //client_finance_details
      finance: {
        quoteId: '',
        homePropertyValve: '',
        investmentProperty: [
          {
            value: '',
            limit:'',
            balance: '',
            lenderName: '',
            monthlyPayment: ''
          }
        ],
        vehicleProperty: [
          {
            value: '',
            balance: '',
            lenderName: '',
            monthlyPayment: ''
          }
        ],
        otherMajorVehicles: '',
        superannuationBalance: '',
        toolsAndEquipment: '',
        sharesTrustsSMSF: '',
        cashInTheBank: '',
        homeContents: '',
        otherMajorAsset: '',
        listOtherMajorAsset: '',
        homeLoanBalance: '',
        homeLoanLimit:'',
        homeLoanLenderName: '',
        homeLoanMonthlyPayment: '',
        personalLoan: [
          {
            balance: '',
            lenderName: '',
            monthlyPayment: ''
          }
        ],
        creditCard: [
          {
            limit: '',
            lenderName: ''
          }
        ],
        privateSchoolFees: '',
        vehicleRunningCosts: '',
        livingExpenses: '',
        insurances: '',
        ratesPowerWater: '',
        entertainment: '',
        otherMajorMonthlyExpenses: '',
        totalMonthlyExpenses: 0
      },
      //client_application_notes
      notes: {
        applicationNotes: ''
      },
      //lookup value
      lookupValues: {
        FBTRate: '0',
        GAPInsurance: '0',
        GAPInsuranceVSA: '0',
        GST: '0',
        GSTLimit: '0',
        GSTMaxOnAssets: '0',
        PPSRFee: '0',
        brokerage: '0',
        brokerageVSADefault: '0',
        brokerageVSA: '0.05',
        id: -1,
        financierId: -1,
        interest: '0',
        leaseAdminFee: '0',
        leaseAdminFeeVSA: '0',
        mcLeaseFee: '0',
        medicare: '0',
        quoteId: -1,
        registration: '0',
        tyreReplaceFreq: '0',
        tyreWheelInsurance: '0'
      },
    },
    saveApplication:'',
    stepNumber:0,
    isLock:false, // it is means can edit/update

    adminQuotePaginateData:{},
    adminQuotePaginate:{},

    quotePaginateData:{},
    quotePaginate:{},

    quoteErrors:{},
    quoteErrorsLocation:'',
    totalExpenses:0,
};

const getters = {
    getQuoteSingle:state => (state.quoteSingle),
    getQuoteSteps:state => (state.quoteSteps),
    getSaveApplication:state => (state.saveApplication),
    getStepNumber:state => (state.stepNumber),
    getIsLock:state=> (state.isLock),

    //Admin 220430
    getAdminQuotePaginateData:state => (state.adminQuotePaginateData),
    getAdminQuotePaginate:state => (state.adminQuotePaginate),

    getQuotePaginateData:state => (state.quotePaginateData),
    getQuotePaginate:state => (state.quotePaginate),

    getQuoteErrors:state => (state.quoteErrors),
    getQuoteErrorsLocation:state => (state.quoteErrorsLocation),

    getTotalExpenses:state => (state.totalExpenses),
};

const actions = {
    async fetchQuoteSingle({ commit }, obj){
        try {
          if(obj.quoteType == 'leads'){
            const response = await leadsService.single(obj.id);
            commit('setQuoteSingle', response.data);

            if(response.data.status == 23  ){
              commit('setIsLock', true);
            }

            return
          }

          const response = await quoteService.single(obj.id);
          commit('setQuoteSingle', response.data);

          if(response.data.status == 2 ||
            response.data.status == 3 ||
            response.data.status == 4 ||
            response.data.status == 5 ||
            response.data.status == 6 ||
            response.data.status == 9 ||
            response.data.status == 10 ||
            response.data.status == 11 ||
            response.data.status == 12 ||
            response.data.status == 13 ||
            response.data.status == 14
          ){
            commit('setIsLock', true);
          }

        } catch (error) {
            const obj = {
                "type":'error',
                "title":error.response.data.error.name,
                "text":error.response.data.error.message,
                "footer":'Error code: ' + error.response.data.error.statusCode,
            }

            messageService.fnSweetAlertDisplay(obj);
        }
    },

    async fetchQuoteSteps({ commit }, obj){
        commit('setQuoteSteps', obj);
    },

    fetchStepNumber({ commit }, step ){
        commit('setStepNumber', step);
    },

    fetchIsLock({ commit }, status){
      commit('setIsLock', status);
    },


    /**
     *
     * @param {*} param0
     * @param {*} obj
     */

     async fetchSaveApplication({ commit }, allData) {



      if(state.isLock == true){
        return
      }

      let res = '';
        try {
          /**
           * This will call on submit
           */
          if(allData.submit_mode == 'submit' ){

            commit('setQuoteErrors', {});

            /**
             * We need to save before submit the data
             * So we need to keep status for old states before call submit
             * we use state.quoteSingle.status
             */
            let obj = allData;
            obj.vehicle.status = state.quoteSingle.status;

            if(allData.quoteType == 'quote'){
              const responseSave = await quoteService.update(
                allData.quoteId,
                JSON.stringify(obj)
              )
            }

            if(allData.quoteType == 'leads'){
              const responseSave = await leadsService.update(
                allData.quoteId,
                JSON.stringify(obj)
              )
            }

            /**
             * Change status for quotes
             * if old status 1 new stats should be 2
             * if old stats 2 or more, new status should be 3
             */
            if(allData.quoteType == 'quote'){
              if(state.quoteSingle.status == 1){
                allData.vehicle.status = 2;
              }else{
                allData.vehicle.status = 3;
              }
            }


            /**
             * Change status for Leads
             * if old status 1 new stats should be 2
             * if old stats 2 or more, new status should be 3
             */
            if(allData.quoteType == 'leads'){
              if(state.quoteSingle.status == 21 || state.quoteSingle.status == 22){
                allData.vehicle.status = 23;
              }
            }

            if(allData.quoteType == 'quote'){
              res = await quoteService.submit(
                allData.quoteId,
                JSON.stringify(allData)
              )
            }

            if(allData.quoteType == 'leads'){
              res = await leadsService.submit(
                allData.quoteId,
                JSON.stringify(allData)
              )
            }

            if (res.data.status_code == 200 && allData.quoteType == 'quote') {

              commit('setSaveApplication', 'success');

              messageService.fnSweetAlertSuccessToast('Quote', 'Submitted successfully')

            }
          }

          /**
           * This will call on Save & Draff
           */
          if(allData.submit_mode == 'save' || allData.submit_mode == 'viewQuote'){

            if(allData.quoteType == 'quote'){
              res = await quoteService.update(
                allData.quoteId,
                JSON.stringify(allData)
              )
            }

            if(allData.quoteType == 'leads'){

              res = await leadsService.update(
                allData.quoteId,
                JSON.stringify(allData)
              )
            }

            if (res.data.status_code == 200) {
              commit('setSaveApplication', 'success');

              if(allData.quoteType == 'leads'){
                messageService.fnSweetAlertSuccessToast('Leads', 'Saved successfully')
              }

              messageService.fnSweetAlertSuccessToast('Quote', 'Saved successfully')

            }
          }
        } catch (error) {
          commit('setSaveApplication', 'fail');
          switch (error.response.status) {
            case 422:
              commit('setQuoteErrors', error.response.data.errors);
              if(allData.quoteType == 'quote'){
                messageService.fnSweetAlertErrorToast(
                  'Quote - update',
                  'There are mandatory data need to complete the quote'
                )
              }

              if(allData.quoteType == 'leads'){
                messageService.fnSweetAlertErrorToast(
                  'Leads - update',
                  'There are mandatory data need to complete the leads'
                )
              }

              break
            case 500:

              if(allData.quoteType == 'quote'){
                messageService.fnSweetAlertErrorToast(
                  'Quote - update',
                  error.response.data.message
                )
              }

              if(allData.quoteType == 'leads'){
                messageService.fnSweetAlertErrorToast(
                  'Leads - update',
                  error.response.data.message
                )
              }

              break
            default:
              if(allData.quoteType == 'quote'){
                messageService.fnSweetAlertErrorToast(
                  'Quote - update',
                  'Something wrong'
                )
              }
              if(allData.quoteType == 'leads'){
                messageService.fnSweetAlertErrorToast(
                  'Leads - update',
                  'Something wrong'
                )
              }

              break
          }
          console.log('fetchSaveApplication', error);
        }
      },

    //Admin 220430
    async fetchAdminQuotePaginate({ commit }, obj){
        commit('setAdminQuotePaginate', obj)
        try {

            const response = await quoteService.listPage(obj);
            commit('setAdminQuotePaginateData', response.data);

        } catch (error) {
            console.log('something wrong - fetchAdminQuotePaginate', error);
        }
    },

    //BDM & Dealer
    async fetchQuotePaginate({ commit }, obj){
      commit('setQuotePaginate', obj)
      try {

        const {role_id} = authService.getUserFromToken();
        /**
         * For BDM - 3
         * For Dealer - 4
         */
        if(role_id == 3){
          const response = await quoteService.listPageBDM(obj);
          commit('setQuotePaginateData', response.data);
        }else if(role_id == 4){
          const response = await quoteService.listPageDealer(obj);
          commit('setQuotePaginateData', response.data);
        }

      } catch (error) {
          console.log('something wrong - fetchQuotePaginate', error);
      }
    },

    fetchQuoteErrors({ commit }, obj){
        commit('setQuoteErrors', obj);
    },

    fetchTotalExpenses ({ commit }, obj){
      let tot = 0

      let homeLoanMonthlyPayment = 0
      let privateSchoolFees = 0
      let vehicleRunningCosts = 0
      let livingExpenses = 0
      let insurances = 0
      let ratesPowerWater = 0
      let entertainment = 0
      let otherMajorMonthlyExpenses = 0

      if (obj.homeLoanMonthlyPayment) {
        homeLoanMonthlyPayment = Number(obj.homeLoanMonthlyPayment)
      }

      if (obj.privateSchoolFees) {
        privateSchoolFees = Number(obj.privateSchoolFees)
      }
      if (obj.vehicleRunningCosts) {
        vehicleRunningCosts = Number(obj.vehicleRunningCosts)
      }
      if (obj.livingExpenses) {
        livingExpenses = Number(obj.livingExpenses)
      }
      if (obj.insurances) {
        insurances = Number(obj.insurances)
      }
      if (obj.ratesPowerWater) {
        ratesPowerWater = Number(obj.ratesPowerWater)
      }
      if (obj.entertainment) {
        entertainment = Number(obj.entertainment)
      }
      if (obj.otherMajorMonthlyExpenses) {
        otherMajorMonthlyExpenses = Number(
          obj.otherMajorMonthlyExpenses
        )
      }

      let arrIP = obj.investmentProperty
      let arrVP = obj.vehicleProperty

      let sumIPMPayment = arrIP.reduce((acc, obj) => {
        return Number(acc) + Number(obj.monthlyPayment)
      }, 0)

      let sumVPMPayment = arrVP.reduce((acc, obj) => {
        return Number(acc) + Number(obj.monthlyPayment)
      }, 0)

      tot =
        Number(homeLoanMonthlyPayment) +
        Number(privateSchoolFees) +
        Number(vehicleRunningCosts) +
        Number(livingExpenses) +
        Number(insurances) +
        Number(ratesPowerWater) +
        Number(entertainment) +
        Number(otherMajorMonthlyExpenses) +
        Number(sumIPMPayment) +
        Number(sumVPMPayment)

      commit('setTotalExpenses', tot)
    },


};

const mutations = {
    setQuoteSingle:(state, res) => (
        state.quoteSingle =  res
    ),
    setQuoteDealerManagerList:(state, res) => (
        state.quoteDealerManagerList =  res
    ),
    setQuoteSteps:(state, res) => (
        state.quoteSteps =  res
    ),

    setSaveApplication:(state, res) => ( state.saveApplication =  res),

    setStepNumber:(state, res) => (
        state.stepNumber =  res
    ),
    setIsLock:(state, res) => (
      state.isLock =  res
    ),

     //Admin 20220430
    setAdminQuotePaginateData:(state, res) => (
        state.adminQuotePaginateData =  res
    ),
    setAdminQuotePaginate:(state, res) => (
        state.adminQuotePaginate =  res
    ),

     //Dealer & BDM
    setQuotePaginateData:(state, res) => (
      state.quotePaginateData =  res
    ),
    setQuotePaginate:(state, res) => (
        state.quotePaginate =  res
    ),

    setQuoteErrors:(state, res) =>(
        state.quoteErrors = res
    ),

    setTotalExpenses:(state, res) =>(
      state.totalExpenses = res
    )

};




export default{
    state,
    getters,
    actions,
    mutations,
}
